import { render, staticRenderFns } from "./PaginatedViewer.vue?vue&type=template&id=347d32d8&scoped=true&"
import script from "./PaginatedViewer.vue?vue&type=script&lang=ts&"
export * from "./PaginatedViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PaginatedViewer.vue?vue&type=style&index=0&id=347d32d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d32d8",
  null
  
)

export default component.exports